var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8681 2.0769V8.28009C5.09607 8.64608 1 12.6848 1 20.1208V22.986L3.026 20.96C5.69255 18.2935 8.93997 17.1763 12.8681 17.5951V23.9231L25.3516 13L12.8681 2.0769ZM15.2417 10.6264V7.30779L21.747 13L15.2417 18.6922V15.555L14.25 15.3897C10.1975 14.7143 6.63071 15.3908 3.61246 17.4108C4.50052 12.8232 7.88271 10.6264 14.0549 10.6264H15.2417Z",
    fill: "#AFD23E",
    stroke: "#2E3D44"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarward);
export default __webpack_public_path__ + "static/media/farward.8ba1e6ac7f1ac80110fef30c7d83e341.svg";
export { ForwardRef as ReactComponent };